/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Chain_EventsInputs */



/**
* | output |
* | --- |
* | "Auto Chain Events On Start Time Update" |
*
* @param {Options_Editor_Auto_Chain_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_chain_events = /** @type {((inputs?: Options_Editor_Auto_Chain_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Chain_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chaîner automatiquement les événements lors de la mise à jour du TC de début")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Kettenereignisse bei Startzeitaktualisierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi a catena automatica all'aggiornamento dell'ora di inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое обновление цепочки событий при запуске")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualización de la hora de inicio de eventos de cadena automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动链式事件在开始时间更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始時間更新時の自動チェーンイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ समय अपडेट पर स्वचालित श्रृंखला घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualização automática de eventos em cadeia na hora de início")
	return /** @type {LocalizedString} */ ("Auto Chain Events On Start Time Update")
});